<h1 mat-dialog-title>{{tittle}}</h1>
<div mat-dialog-content style="width: 30vw;">
  <p>{{message}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button color="primary" (click)="onNoClick()">{{cancelButtonText}}</button>
  <button mat-button color="success" class="text-success" (click)="onYesClick()"  cdkFocusInitial>{{confrimButtonText}}</button>
</div>